import { connect } from 'react-redux'
import request from '../../utils/request'
import { retrieveUserFromToken } from '../../user/UserActions'
import UserLogged from '../components/UserLogged'
import { browserHistory } from 'react-router';


const mapStateToProps = (state) => {
    return {
        user : state.user
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        retrieveUserFromToken: () => {
            return dispatch(retrieveUserFromToken()).catch(function(error){
				dispatch({type:'LOGOUT_USER'})
				request.defaults.headers.common['Authorization'] = ""
				localStorage.removeItem('token')
				localStorage.clear()
				browserHistory.push('/login')
				window.location.reload()
            })
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserLogged)



// WEBPACK FOOTER //
// ./src/user/containers/UserLoggedContainer.js